import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  computed,
  inject,
} from '@angular/core';
import { DemoExportPreviewService } from '@core/services/demo-export-preview.service';

/**
 * 演示环境的「导出成功」预览弹窗。
 *
 * 演示时智能体点完导出，客户只看到「导出成功」一行提示和一个落进下载目录的
 * 文件 —— 文件在哪儿、长什么样，他看不见。所以导完就把这张表原样弹出来：
 * 蒙版 + 一张仿 Excel 的表（行号、表头、网格线、底部 sheet 标签），看完关掉。
 *
 * 数据就是刚写进 xlsx 的那份（`PromotionService.exportToExcel()` 里顺手攒的），
 * 不是另编一份假的 —— 弹出来的和下载下来的必须是同一张表，否则演示就穿帮了。
 *
 * 🔴 两条踩过的取舍：
 *   1. **只在演示环境挂**（见 app.component.html 的 `@if (isDemo)`）。真实环境
 *      导完再弹一层表纯属打扰，这个组件自己不重复判一次环境。
 *   2. **z-index 3000，压在演示光标（4000）下面**。演示时智能体还要点「关闭」，
 *      箭头得在弹窗之上看得见 —— 反过来就被自己盖住了。
 */
@Component({
  selector: 'app-demo-export-preview',
  templateUrl: './demo-export-preview.component.html',
  styleUrl: './demo-export-preview.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoExportPreviewComponent {
  private readonly previewService = inject(DemoExportPreviewService);

  readonly payload = this.previewService.payload;
  readonly visible = computed(() => this.payload() !== null);

  close(): void {
    this.previewService.close();
  }

  /** Esc 关弹窗 —— 弹窗类的通用习惯，缺了会让人觉得关不掉 */
  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.visible()) {
      this.close();
    }
  }
}
